var map = {
	"./group-01.jpg": 80182,
	"./group-02.jpg": 69761,
	"./group-03.jpg": 91716,
	"./group-04.jpg": 86031,
	"./group-05.jpg": 18098,
	"./group-06.jpg": 11645,
	"./group-07.jpg": 72416,
	"./group-08.jpg": 77883,
	"./group-09.jpg": 6750,
	"./group-10.jpg": 92116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58569;